import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ERROR_MAP, MESSAGE_LIFE } from './error.interceptor.utils';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const mapped = ERROR_MAP[error.status];
      const skipFor = req.headers.get('X-Skip-Error-Popup');
      const shouldSkip = skipFor?.split(',').map(Number).includes(error.status);
      if (!shouldSkip) {
        messageService.add({
          severity: 'error',
          summary: mapped?.summary ?? 'Errore',
          detail:
            error.error?.message ?? mapped?.detail ?? 'Si è verificato un errore inaspettato.',
          life: MESSAGE_LIFE,
        });
      }

      return throwError(() => error);
    })
  );
};
